import React, { useEffect } from "react";
import { useGetTablesdataMutation } from "./TablesourceApiSlice";

const TableSource = ({ selectedTable, connectionId }) => {
  const [getTablesdata, { data, isLoading, isError, isSuccess }] =
    useGetTablesdataMutation();

  useEffect(() => {
    getTablesdata({ selectedTable, connectionId });
  }, [selectedTable, connectionId]);

  let TableContent;
  if (isLoading) {
    TableContent = <p>Loading...</p>;
  }
  if (isError) {
    TableContent = <p></p>;
  }

  if (isSuccess) {
    const { mappedColumnArray, data: tableData } = data;
    console.log(mappedColumnArray);
    console.log(tableData);
    if (
      !mappedColumnArray ||
      !Array.isArray(mappedColumnArray) ||
      mappedColumnArray.length === 0
    ) {
      TableContent = <p>No columns available</p>;
    } else if (
      !tableData ||
      !Array.isArray(tableData) ||
      tableData.length === 0
    ) {
      TableContent = <p>No data available</p>;
    } else {
      TableContent = (
        <div className="w-full h-[30rem] lg:h-full lg:w-[70%]">
          <h2 className="font-medium">
            Data Preview{" "}: 
            {/* <span className="text-blue-950">{selectedTable}</span> */}
          </h2>
          <div className="h-[99%] overflow-hidden overflow-y-auto">
            <table className="border border-gray-300 border-collapse w-full text-sm">
              <thead className="bg-gray-100  text-left sticky top-0">
                <tr>
                  {mappedColumnArray.map((column, index) => (
                    <th key={index} className="p-2 bg-gray-200 font-bold  ">
                      {column.columnName}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tableData.map((rowData, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className={`border-b border-gray-300 ${rowIndex % 2 === 0 ? 'bg-gray-100' : 'bg-white'}`}
                  >
                    {mappedColumnArray.map((column, colIndex) => (
                      <td
                        key={colIndex}
                        className="p-2 border border-gray-300 truncate"
                      >
                        {rowData[column.columnName]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }

  return TableContent;
};

export default TableSource;
